import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import DataSetsPanel from 'components/DataSetsPanel/DataSetsPanel';
import Select from 'components/Select/Select';
import TextField from 'components/TextField/TextField';
import {
  EU_TAXONOMY_CODE,
  NACE_CODE,
  NACE_SECTION,
} from 'constants/formFields';

import type { FieldValues, Path } from 'react-hook-form';
import type IFieldError from 'store/types/IFieldError';
import type { IDetailSection } from './interfaces/IDetailSection';

function DetailSection<T extends FieldValues>({
  control,
  naceCodesData,
  naceDivisions,
  onNaceSelectionChange,
  placeholder,
  recordId,
}: IDetailSection<T>) {
  const { t } = useTranslation();

  return (
    <DataSetsPanel title={t('customers.selections.details')}>
      <Controller
        control={control}
        name={NACE_SECTION as Path<T>}
        render={({
          field: {
            value,
            onChange,
          },
          fieldState: { error },
        }) => (
          <Select
            label={t('customers.fields.sector')}
            placeholder={recordId ? placeholder : t('customers.fields.sector')}
            options={naceCodesData}
            value={value?.value ? value : undefined}
            onChange={(newValue) => {
              onChange(newValue);
              onNaceSelectionChange();
            }}
            error={error?.message || (error as IFieldError)?.value?.message}
            menuPosition="absolute"
            isSearchable
            required
          />
        )}
      />
      <Controller
        control={control}
        name={NACE_CODE as Path<T>}
        render={({
          field: {
            value,
            onChange,
          },
          fieldState: { error },
        }) => (
          <Select
            label={t('customers.fields.industry')}
            placeholder={recordId ? placeholder : t('customers.fields.industry')}
            options={naceDivisions}
            value={value || null}
            onChange={onChange}
            error={error?.message}
            menuPosition="absolute"
            isSearchable
          />
        )}
      />
      <Controller
        control={control}
        name={EU_TAXONOMY_CODE as Path<T>}
        render={({ field: { name, value, onChange }, fieldState: { error } }) => (
          <TextField
            name={name}
            value={value}
            label={t('customers.fields.euTaxonomyActivityCode')}
            error={error?.message}
            onChange={(event) => onChange(event.target.value)}
            placeholder={placeholder || t('customers.fields.euTaxonomyActivityCode')}
          />
        )}
      />
    </DataSetsPanel>
  );
}

export default DetailSection;
